<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset, errors}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model"
                   :title="model.uuid ? $t(`Update Collection`) : $t(`Create New Collection`)"
                   @show="onShow" @hidden="onHidden" @ok.prevent="onSubmit"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading"
                   scrollable modal-class="mobile-full-screen">
      <translatable-input-widget :hint="false" input-class="col-md-12"
                                 :model="model" :fields="model.sorted_dynamic_fields_template" :errors="errors"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../../core/components/artisio-modal/ArtisioModal";
  import CollectionModel from "@/modules/sales/view/collections/Collection.model";
  import TranslatableInputWidget from "@/core/widgets/TranslatableInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('sales');

  export default {
    name: "CollectionModal",
    components: {
      TranslatableInputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new CollectionModel()
      }
    },
    computed: {
      ...mapState({
        modal: state => state.collectionModal,
        editObject: state => state.collectionModal.object,
        sale: state => state.collectionModal.sale,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          let tmpData = this.editObject
          tmpData.dynamic_fields = tmpData.translations
          this.model = new CollectionModel(this.editObject);
        }
      },
    },
    methods: {
      ...mapActions(['hideCollectionModal', 'createSaleCollection', 'updateSaleCollection']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new CollectionModel();
        this.hideCollectionModal();
      },
      async onSubmit() {
        this.$nextTick(() => {
          this.runSubmitLogic()
        });
      },
      async runSubmitLogic() {
        await this.$refs.observer.reset()
        let validateSuccess = await this.$refs.observer.validate()
        if (!validateSuccess) {
          return
        }

        this.model.assignToDynamicFields()

        const payload = {
          auction_uuid: this.sale.uuid,
          translations: this.model.dynamic_fields,
        }

        let response;
        let message;
        if (!this.model.uuid) {
          response = await this.createSaleCollection(payload)
          message = this.$i18n.t('Collection was successfully created')
        } else {
          response = await this.updateSaleCollection({...payload, uuid: this.model.uuid})
          message = this.$i18n.t('Collection was successfully updated')
        }

        if (response.success) {
          this.$toast('success', message)
          this.showConfirmation = false
          this.hideCollectionModal()
        } else {
          this.model.setMultipleErrors(response.body)
        }
      },
    }
  }
</script>

<style scoped>

</style>

